module.exports = __webpack_public_path__ + "static/media/Heilung Musik fr Krper und Seele - Natrliche Hypnose.036e8a0b.mp3";